import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ReactHtmlParser from 'react-html-parser';
import dompurify from 'dompurify';

import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import {
    currentLanguage
} from "src/shared_modules/i18n";

import 'src/shared_modules/veu-visitors-core/components/popovers/popovers.css';


class PopoverGlobalNotice extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {

    }
    render() {
        if (this.props.disabled === true)
            return (null);

        if (!this.props.globalNotice)
            return (null);

        if (!this.props.globalNotice.enabled)
            return (null);

        if (!this.props.globalNotice.onAir)
            return (null);

        let currentLangi18n = currentLanguage();

        const sanitizer = dompurify.sanitize;

        return (<div className="popover globalNotice reminderStream">
            <h1>{this.props.globalNotice.title[currentLangi18n.code2]}</h1>
            <div>
                {ReactHtmlParser(sanitizer(this.props.globalNotice.description[currentLangi18n.code2], { ADD_ATTR: ['target'] }))}
            </div>
        </div>);
    }
}
/*
 * ---------------------------------------------------------------------
 * prop Types
 * ---------------------------------------------------------------------
 */
PopoverGlobalNotice.propTypes = {
    globalNotice: PropTypes.object,
    currentLang: PropTypes.string,
};

/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */

const mapStateToProps = (state, ownProps) => {
    return {
        globalNotice: state.event.globalNotice,
        currentLang: state.system.currentLang,
    };
};

const mapDispatchToProps = {
    showPopover,
    hidePopover,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PopoverGlobalNotice);
